import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MustahzarService {

constructor(private http:HttpClient) { }


getMustahzar(page:any){

  return this.http.get<any[]>(environment.apiUrl+"medicines");
}

}
